import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";

import Typography from "@material-ui/core/Typography";
import { GoogleMap, Marker } from "@react-google-maps/api";
import axios from "axios";
import { Close, PlayCircleFilled } from "@material-ui/icons";
import {Dialog, Popper} from "@material-ui/core";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Auth from "../../auth/auth";
import { LanguageContext } from "../../containers/languageprovider";
import { returnStringTranslation } from "../printLanguageSelect";

import {
  Button,
  Grid,
  Modal,
  Snackbar,
  Box,
  Popover,
  TextField,
  FormControl,
} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import { Carousel } from "react-responsive-carousel";
import Footer from "../Footer";
import HeaderBuilding from "../HeaderBuilding";
import { LeftIcon, RightIcon } from "../iconlist";
import {
  returnDescriptionById,
  getAssetClassesText,
  getFeaturesArray,
  getCityBreadCrumb,
  DecorateBuilding,
  DecorateBuildingWithUnits,
} from "../utils";
import parseHtml from "html-react-parser";

import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import MuiAlert from "@material-ui/lab/Alert";
import { buildingsStore, searchStore } from "../../lib/store";
import BuildingFormCard from "../buildingFormCard";
import UnitsTable from "../UnitsTable";
import UnitsTableMobile from "../UnitsTableMobile";
import queryString from "query-string";
import BuildingMediaModal from "../BuildingMediaModal";
import globalStyles from "../globalStyles";
import BuildingAmenities from "../BuildingAmenities";
import RequestInformationForm from "../RequestInformationForm";
import SendARequestDialog from "../broker-views/SendARequestDialog";
import SearchRequestsModal from "../../SearcherRequestsModal/SearchRequestsModal";
import {
  API_URL_ALLCOMMERCIALFEATURES,
  API_URL_ALLMACROAREA,
  API_URL_ALLTECHNICALFEATURES,
} from "../../config/config";
import { useSelector } from "react-redux";
import HowItWorksModal from "../../SearcherRequestsModal/HowItWorksModal";
import useIdleTimeout from "../utils/useIdleTimeout";
import {isoLanguageMap} from "../languages";
import zIndex from "@material-ui/core/styles/zIndex";


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  BoxTitle: {
    borderBottom: "1px solid #E5E5E5",
    minHeight: "60px",
  },
  column1: {
    flexBasis: "60%",
  },
  column2: {
    flexBasis: "40%",
    textAlign: "right",
  },

  InformationRequestTitle: {
    fontFamily: "Barlow",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "24px",
    letterSpacing: "0em",
    textAlign: "left",
    color: "#6A6A6A",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  TraverseListing: {
    width: "100%",
    height: "24px",
  },
  ListingArrow: {
    position: "absolute",
    display: "flex",
    textDecoration: "none",
    color: "#6A6A6A",
  },
  ListingArrowMobile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    color: "#6A6A6A",
  },
  ListingArrowText: {
    lineHeight: "inherit",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  PaperSendRequestInfo: {
    position: "static",
    padding: 20,
    border: "1px solid #E5E5E5",
    boxSizing: "border-box",
    boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.12)",
    borderRadius: "16px",
    width: "400px",
  },
  PaperSendRequestInfoBottom: {
    position: "absolute",
    bottom: "0px",
    padding: 20,
    border: "1px solid #E5E5E5",
    boxSizing: "border-box",
    boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.12)",
    borderRadius: "16px",
  },

  PaperSendRequestInfoFixed: {
    position: "fixed",
    top: "84px",
    padding: 20,
    border: "1px solid #E5E5E5",
    boxSizing: "border-box",
    boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.12)",
    borderRadius: "16px",
    width: "400px",
    maxHeight: "90vh",
    overflow: "auto",
  },
  table: {
    //border: "1px solid #B6B6B6"
    color: "#B6B6B6",
  },

  tableCell1: {
    borderBottom: "1px solid #B6B6B6",
    fontVariant: "all-small-caps",
  },
  tableCell: {
    borderBottom: "1px solid #B6B6B6",
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "30px",
    color: "#000000",
    textAlign: "left",
  },

  tableCellNearby1: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: 300,
    fontSize: "16px",
    lineHeight: "5px",
    color: "#000000",
    borderBottom: "none",
    width: "50%",
  },
  tableCellNearby: {
    borderBottom: "none",
    width: "25%",
  },

  buildingName: {
    fontFamily: "Montserrat",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 24,
    color: "#000000",
  },

  brokerName: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 21,
    lineHeight: "36px",
    color: "#000000",
  },

  brokerWeb: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 16,
    lineHeight: "21px",
    color: "#000000",
    textDecoration: "underline",
  },

  buildingNameHeader: {
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#000000",
    // marginLeft:"60px"
  },

  ChipInfo: {
    width: "100%",
    height: "56px",
    background: "#F5F5F5",
    borderRadius: "10px",
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "left",
    paddingRight: "auto",
  },

  buildingInfo: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 16,
    lineHeight: "24px",
    color: "#000000",
  },

  BoxFacilities: {
    width: "100%",
    /*height: "390px",            */
    background: "rgba(28, 85, 229, 0.1)",
    borderRadius: "16px",
    paddingBottom: "40px",
  },

  Divider: {
    border: "2px dashed #000000",
    background: "#ffffff",
  },

  ImageBroker: {
    [theme.breakpoints.down("sm")]: {
      margin: 0,
      padding: 10,
    },
    margin: 10,
    borderRadius: 10,
    height: "70px",
    width: "100%",
    objectFit: "contain",
  },
  boxSlider: {
    [theme.breakpoints.down("xs")]: {
      height: 300,
      // paddingLeft:"20px",
      // paddingRight:"20px",
    },
    paddingTop: 10,
    paddingRight: 5,
    paddingLeft: 5,
    display: "flex",
    width: "100%",
    height: "100%",
    flexGrow: 1,
    flexBasis: 0,

    // margin: 10,
  },
  imgSlider: {
    // width: "auto",
    // height: "450px",
    width: "100%",
    height: "auto",

    maxWidth: "100%",
    maxHeight: "500px",

    objectFit: "cover",
    backgroundRepeat: "no-repeat",
    // margin: "auto",
    // margin: 10,
    borderRadius: 10,
  },
  visualContentButton: {
    fontFamily: "Barlow",
    backgroundColor: "#1c55e5",
    color: "white",
    fontSize: "16px",
  },
  visualContentButtonMobile: {
    fontFamily: "Barlow",
    color: "#1c55e5",
  },

  ImageSlider: {
    margin: 10,
    borderRadius: 20,
  },

  DivSlider: {
    paddingTop: 10,
    paddingLeft: 20,
  },
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24,
    backgroundColor: "#ffffff",
    height: 74,
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  rightToolbar: {
    marginLeft: "auto",
    marginRight: -12,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  // CompanyListRequest: {
  //   [theme.breakpoints.down("sm")]: {
  //     display: "none",
  //   },
  // },

  buttonVirtual: {
    margin: theme.spacing(1),
    borderRadius: "10px",
    color: "#B6B6B6",
    BorderColor: "#B6B6B6",
    boxShadow: "none",
    border: "1px solid",

    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",

    letterSpacing: "0.03em",
    fontVariant: "all-small-caps",
  },
  button: {
    margin: theme.spacing(1),
    borderRadius: "10px",

    BorderColor: "#5AC071",
    boxShadow: "none",
    border: "1px solid",
    //backgroundColor: "",
    color: "#5AC071",
  },

  ArrowsCarousel: {
    width: "50px",
    height: "50px",
    position: "absolute",
    zIndex: 2,
    top: "calc(50% - 25px)",
    cursor: "pointer",
  },
  IconArrow: {
    width: "100%",
    height: "100%",
    "&:hover": {
      opacity: 1,
      borderColor: "red",
    },
  },
  buttonMap: {
    boxShadow: "none",
    border: "1px solid #1C55E5",
    color: "#1C55E5",
    fontFamily: "Barlow",
    letterSpacing: "0.03em",
    fontWeight: 500,
    fontSize: "16px",
    boxSizing: "border-box",
    borderRadius: "10px",
    fontVariant: "all-small-caps",
  },

  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    paddingTop: 10,
    paddingBottom: 10,
  },
  SectionTitle: {
    fontFamily: "Montserrat",
    fontStyle: "medium",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "21px",
    color: "#000000",
    paddingTop: 20,
    paddingBottom: 20,
  },
  SectionSubTitle: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "21px",
    lineHeight: "21px",
    color: "#000000",
    margin: "40px",
  },

  // SectionInfo: {
  //   margin: 10,
  //   [theme.breakpoints.down("sm")]: {
  //     margin: 0,
  //   },
  // },

  SectionAccordion: {
    marginBottom: 50,
  },

  FacilitiesInfo: {
    paddingTop: 49,
    paddingLeft: 44,
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "21px",
    lineHeight: "21px",
    color: "#1C55E5",
  },

  FacilitiesInfoSub: {
    paddingTop: 40,
    paddingLeft: 44,
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#1C55E5",
  },

  FeatureList: {
    paddingTop: 0,
    paddingLeft: 64,
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#1C55E5",
    margin: "5px",
  },

  ArrowIcon: {
    fontSize: "32px",
  },

  appBarSpacer: theme.mixins.toolbar,

  breadCrumbsSpace: {
    height: "125px",
  },
  content: {
    flexGrow: 1,
    height: "100vh",
  },
  container: {
    [theme.breakpoints.down("xs")]: {
      margin: 0,
      paddingTop: 20,
    },
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    maxWidth: "1600",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  pos: {
    marginBottom: 12,
  },
  imageList: {
    flexWrap: "nowrap",
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: "translateZ(0)",
    /*width: "100%",
    height: 450,*/
  },
  icon: {
    color: "rgba(255, 255, 255, 0.54)",
  },

  titleBar: {
    background: theme.breadCrumbsBar.background,
  },

  Banner: {
    height: "400px",
  },
  Media: {
    height: "480px",
  },
  buildingPageInfo: {
    backgroundColor: "white",
    color: "black",
    padding: "20px 24px",
  },

  MediaCaption: {
    position: "absolute",
    bottom: "25px",
    paddingLeft: "15px",

    backgroundColor: "black",
    color: "white",
    opacity: 0.6,
    width: "100%",
    height: "25px",
    /*text-overflow: ellipsis;





    font:
    {
        size: $header-font-size;
        weight: 200;
    }

    transition: 300ms;
    cursor: pointer;
    &:hover
    {
        opacity: 0.8;
    }*/
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
    minWidth: 120,
    maxWidth: "100%",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  AddressInfo: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#000000",
  },
  AddressInfo2: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "32px",
    color: "#000000",
    paddingBottom: "10px",
  },
  NearbyInfoTitle: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "21px",
    lineHeight: "24px",
    color: "#000000",
    paddingTop: "40px",
    paddingBottom: "20px",
  },
  NearbyPoint: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    fontVariant: "all-small-caps",
    color: "#6a6a6a",
    // color: "#1C55E5",
    paddingTop: "40px",
  },
  IconNearbyPoint: {
    height: 19,
    width: 18,
    marginRight: 10,
  },
  heading: {
    width: "100%",
  },

  breadCrumpsBar: {
    height: 6,
    background: theme.breadCrumbsBar.background,
  },
  buttonCompare: {
    background: "#1C55E5",
    borderRadius: "10px",
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center",
    letterSpacing: "0.03em",
    textTransform: "uppercase",
    color: "#FFFFFF",
    height: "46px",
    width: "60%",
    marginLeft: "20%",
    "&:hover": {
      background: "#1C55E5",
      opacity: 0.6,
    },
  },
  solutionsTab: {
    fontSize: "23px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
    fontWeight: 500,
    padding: "2px",
    cursor: "pointer",
    color: "#391400",
  },
  brokerImage: {
    height: "70px",
    width: "120px",
    objectFit: "contain",
  },
  StickyBar: {
    backgroundColor: "white",
    color: "black",
    top: "0",
    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.5), 0 2px 4px 0 rgba(0, 0, 0, 0.2)",
  },
}));

const containerStyle = {
  width: "100%",
  height: "400px",
};

//{JSON.parse(buildingedit.addressdetails).address_components[0]}

export default function BuildingPresentation({
  API,
  apiParameter,
  setMetaTags,
  isToken,
  // isoLanguageMap,
}) {
  const globalClasses = globalStyles();
  const [breadCityUrl, setBreadCityUrl] = useState(false);
  const [breadCityLabel, setBreadCityLabel] = useState(false);
  const [breadMacroareaUrl, setBreadMacroareaUrl] = useState(false);
  const [breadMacroareaLabel, setBreadMacroareaLabel] = useState(false);

  const [companyPage, setCompanyPage] = React.useState("");

  const history = useHistory();
  const [adjacentListings, setAdjacentListings] = useState();

  //change the way we are getting the cashed search

  const cachedSearch = searchStore();

  const cities = buildingsStore((state) => state.cities);

  const { search } = window.location;
  const values = queryString.parse(search);
  const [images, setImages] = useState([]);
  const [listdocs, setListDocs] = useState([]);
  const [listunits, setListUnits] = useState([]);
  const [listmacroarea, setMacroAreaList] = useState([]);
  const [listTech, setTechList] = useState([]);
  const [listComm, setCommList] = useState([]);
  const { dictionary, userLanguage } = React.useContext(LanguageContext);
  const [currentScrollY, setCurrentScrollY] = useState(0);
  const location = useLocation();
  const theme = useTheme();
  const MobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const elementRefCar = useRef(false);
  const elementRefBody = useRef(false);
  const elementRefPaper = useRef(false);
  const prevScrollY = useRef(0);
  const [expanded, setExpanded] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [alertseverity, setAlertSeverity] = React.useState("success");
  const [alertmsg, setAlertMsg] = React.useState(false);
  const [buildingNotFound, setBuildingNotFound] = React.useState(false);
  const [anchorElPopover, setAnchorElPopover] = React.useState(null);
  const openPopover = Boolean(anchorElPopover);
  const idPopover = openPopover ? "simple-popover" : undefined;
  const [isCopied, setIsCopied] = React.useState(false);
  const [openMediaModal, setOpenMediaModal] = React.useState(false);
  const [openRequest, setOpenRequest] = React.useState(false);
  const [openSearchRequestsModal, setOpenSearchRequestsModal] =
    React.useState(false);
  const [searchRequestData, setSearchRequestData] = useState({
    assetClass: 1,
    dealType: 1,
    location: "",
  });
  const [slug, setSlug] = useState("");
  const footerRef = useRef();
  const cachedSearchKey = useSelector((state) => state.cachedSearchKey);
  const [openHowItWorksDialog, setOpenHowItWorksDialog] = useState(false)




  const [anchorEl, setAnchorEl] = useState(null);
  const [PopperId, setPopperId] = useState(null);

  const idPopperUnpayed = "idPopperUnpayed";
  const popperOpenUnpayed = Boolean(PopperId===idPopperUnpayed);

  const handleMouseEnter = (event) => {
    // console.log("handleMouseEnter: %o",event.currentTarget.getAttribute("dataId"));
    setAnchorEl(event.currentTarget);
    setPopperId(event.currentTarget.getAttribute("dataId"));
  };

  const handleMouseLeave = () => {
    // console.log("handleMouseLeave");
    setAnchorEl(null);
    setPopperId(null);
  };



  //idle timer for dialog searcher cta
  const { isIdle, setIdle, idleTimer, stopIdleTimer } = useIdleTimeout({
    idleTime: 10,
    onIdle: () => {
      HandleOpenRequestDialog();
    },
  });

//states for breadcrumb
  const [breadcrumbMacroArea, setBreadcrumbMacroArea] = useState("");
  const [cityBreadCrumb, setCityBreadCrumb] = useState("");


  const HandleOpenRequestDialog = () => {
    if (adjacentListings) {
      if(adjacentListings?.right == undefined && adjacentListings?.left.length > 0){
      setRequestDialogOpen(true);
      stopIdleTimer();
      return;
      }
    } else {
      const cachedSearchValue = cachedSearch.getValue(cachedSearchKey);
      if(cachedSearchValue?.buildingList?.length === 1){
        setRequestDialogOpen(true);
      }
      stopIdleTimer();
      setIdle(false);
      return;
    }
  };


  const handleOpenSearchRequestsModal = () => {
    setOpenSearchRequestsModal(true);
  };

  const handleCloseSearchRequestsModal = () => {
    setOpenSearchRequestsModal(false);
  };
  const [requestDialogOpen, setRequestDialogOpen] = React.useState(false);
  const handleExpand = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleRequestDialogClick = () => {
    setOpenSearchRequestsModal(true);
    setRequestDialogOpen(false);
  };

  const handleCloseRequest = () => {
    setOpenRequest(false);
  };

  // prevScrollY is needed otherwise the state value if not correctly updated
  React.useEffect(() => {
    const headerScroll = () => {
      const scrollY = window.scrollY;
      if (
        (prevScrollY.current > 100 && scrollY < 100) ||
        (prevScrollY.current < 100 && scrollY > 100)
      ) {
        setCurrentScrollY(scrollY);
        prevScrollY.current = scrollY;
      }
    };
    headerScroll();

    window.addEventListener("scroll", headerScroll);
    return () => window.removeEventListener("scroll", headerScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const targetRef = useRef();

  const handleClickSolutions = (event) => {
    event.preventDefault();
    targetRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };

  const [buildingedit, setbuildingedit] = useState({
    slug,
    favoritesid: null,
    name: "",
    description: "",
    address: "",
    lat: 45.4642035,
    lng: 9.189982,
    officetype: "1",
    virtual_tour: "",
    macroarea_list: "",
    technical_features: "",
    commercial_features: "",
  });

  const [listCompany, setlistCompany] = React.useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);

  const [value, setValue] = React.useState(
    images.length > 0
      ? "gallery"
      : buildingedit.virtual_tour !== null &&
        buildingedit.virtual_tour !== "" &&
        buildingedit.virtual_tour !== undefined
      ? "virtual_view"
      : buildingedit.video !== null &&
        buildingedit.video !== "" &&
        buildingedit.video !== undefined
      ? "video"
      : "map"
  );

  const classes = useStyles();

  const SwitchOnChange = (event) => {
    setbuildingedit({
      ...buildingedit,
      favoritesid: event,
    });
  };

  React.useEffect(() => {
    axios
        .get(API_URL_ALLTECHNICALFEATURES, {
          headers: {
            Authorization: "Bearer " + Auth.getToken(),
            "Content-Type": "application/json",
          },
        })
        .then((payload) => {
          setTechList(payload.data.all);
        });

    axios
        .get(API_URL_ALLCOMMERCIALFEATURES, {
          headers: {
            Authorization: "Bearer " + Auth.getToken(),
            "Content-Type": "application/json",
          },
        })
        .then((payload) => {
          setCommList(payload.data.all);
        });

    axios
        .get(API_URL_ALLMACROAREA, {
          headers: {
            Authorization: "Bearer " + Auth.getToken(),
            "Content-Type": "application/json",
          },
        })
        .then((payload) => {
          setMacroAreaList(payload.data.all);
        });

    axios
        .get(API + apiParameter, {
          headers: {
            Authorization: "Bearer " + Auth.getToken(),
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          // console.log("token data :\n", res.data);
          res.data.lng = Number(res.data.lng);
          res.data.lat = Number(res.data.lat);
          DecorateBuildingWithUnits(res.data);
          // console.log("token data after decorating :\n", res.data);

          setbuildingedit(res.data);
          setSlug(res.data.slug);
          setImages(res.data.building_photos || []);
          setListDocs(res.data.building_docs || []);
          setListUnits(res.data.units);
          setlistCompany(res.data.companies);
          if (companyPage && !companyPage.id) {
            setCompanyPage(
                res.data.companies.find((e) => e.id === Number(companyPage))
            );
          }
        })
        .catch((error) => {
          if (typeof error.response.status === "undefined") {
            history.push("/#modal-something-went-wrong");
          } else if (error.response.status === 422) {
            history.push("/#modal-expired");
          } else if (error.response.status === 401) {
            history.push("/login#not-logged");
          } else if (error.response.status === 403) {
            setAlertMsg(dictionary.BuildingTokenError404);
            history.push("/#modal-wrong-company");
          } else if (error.response.status === 404) {
            history.push("/#modal-wrong-company");
          } else {
            history.push("/#modal-something-went-wrong");
          }
        });


    if (isToken) {
      // console.log("exit on token");
      return;
    }
    // console.log("useEffect setAdjacentListings");
    window.scrollTo(0, 0);
    // clear left right
    setAdjacentListings(undefined);
    // if previous state location is searchresults ( works with back arrow and refresh too )
    // find closest left right building

    // console.log("Evaluations %o %o",history.location.state?.prev?.split("/")[1],(history.location.state?.prev?.split("/")[1] !== "searchresults"))
    if (history.location.state?.prev?.split("/")[1] !== "searchresults") {
      // console.log("exit on history");
      return;
    }
    // console.log("setAdjacentListings is true");
    const currentID = Number(history.location.state?.buildingId);

    const cachedSearchValue = cachedSearch.getValue(cachedSearchKey);


    // console.log("cachedSearchValue : ", cachedSearchValue);

    /**
     *
     * 1- we get the key from redux
     *
     * 2- we get the cachedsearch with the key then we enter the buildingList
     *
     * 3- store the value in a variable cuz we gonna use it later
     *
     */

    const currentIndex = cachedSearchValue?.buildingList?.findIndex(
        (b) => b.id === currentID
    );

    // console.log("Evaluations: %o [%o]",cachedSearchValue?.buildingList?.length ||0 ,(cachedSearchValue?.buildingList?.length || 0 <= 1));
    if ((cachedSearchValue?.buildingList?.length || 0) <= 1) {
      // console.log("exit on cachedSearchValue");
      return;
    }
    //this condition is false because the cashedsearch is undefined
    // console.log("setAdjacentListings 2 is true");

    let leftID, rightID;
    let left, right;
    if (
        currentIndex > 0 &&
        currentIndex < cachedSearchValue.buildingList?.length - 1
    ) {
      rightID = cachedSearchValue.buildingList[currentIndex + 1].id;
      right = cachedSearchValue.buildingList[currentIndex + 1].slug;
      leftID = cachedSearchValue.buildingList[currentIndex - 1].id;
      left = cachedSearchValue.buildingList[currentIndex - 1].slug;
    } else if (currentIndex === 0) {
      rightID = cachedSearchValue.buildingList[currentIndex + 1].id;
      right = cachedSearchValue.buildingList[currentIndex + 1].slug;
    } else if (
        currentIndex ===
        cachedSearchValue.buildingList.length - 1
    ) {
      leftID = cachedSearchValue.buildingList[currentIndex - 1].id;
      left = cachedSearchValue.buildingList[currentIndex - 1].slug;
    }

    setAdjacentListings({
      left,
      right,
      leftID,
      rightID,
    });

    const urlSearchParams = new URLSearchParams(window.location.search);
    const assetClass = urlSearchParams.get("assetClass");
    const dealType = urlSearchParams.get("dealType");
    const id_location = buildingedit.macroarea_list;
    let location = returnDescriptionById(
        id_location,
        listmacroarea,
        userLanguage
    );

    setSearchRequestData({
      assetClass: assetClass || searchRequestData.assetClass,
      dealType: dealType || searchRequestData.dealType,
      location: location || searchRequestData.location,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiParameter]);

  React.useEffect(() => {
    const listener = (e) => {
      if (e.key === "Escape") {
        setSelectedCenter(null);
      }
    };
    window.addEventListener("keydown", listener);
    return () => {
      window.removeEventListener("keydown", listener);
    };
  }, []);

  React.useEffect(() => {
    console.log("Location searchRequestData: %o", searchRequestData);

  }, [searchRequestData]);

  const [isFromSearch, setIsFromSearch] = React.useState(false);
  const [filteredUnits, setFilteredUnits] = React.useState([]);
  const [selectedSolution, setSelectedSolution] = React.useState("matched");
  useEffect(() => {
    setIsFromSearch(false);

    if (
      values.fromSearch === "true" &&
      values.assetClass !== "undefined" &&
      values.dealType !== "undefined" &&
      values.dealType &&
      values.assetClass
    ) {
      setIsFromSearch(true);
      setFilteredUnits(
        listunits.filter(
          (unit) =>
            unit.asset_class === Number(values.assetClass) &&
            unit.deal_type === Number(values.dealType)
        )
      );
    }
  }, [location, search, listunits]);
  //

  useEffect(() => {
    console.log("buildingedit", buildingedit)
    if (setMetaTags) {
      const cleanupAlternateLinks = setMetaTags(buildingedit);
      return cleanupAlternateLinks;
    }
  }, [buildingedit]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if(params.get('dealType') && params.get('assetClass') && buildingedit?.detailAddress){
      const deal_type = params.get('dealType')
      const asset_class = params.get('assetClass')
      const city_url = `/searchresults?citySelect=${buildingedit.detailAddress.getCity(userLanguage)}&dealType=${deal_type}&assetClass=${asset_class}&language=${userLanguage}`

      setCityBreadCrumb(city_url)
    }
    else if (buildingedit?.units?.length > 0){
      const deal_type = buildingedit?.units[0]?.deal_type?.toString();
      const asset_class = buildingedit?.units[0]?.asset_class?.toString();
      let macroarea_id =  buildingedit.macroarea_list?.split(",")?.[0]
      let macroAreaValue = returnDescriptionById(macroarea_id, listmacroarea, userLanguage);

      const city_url = `/searchresults?citySelect=${buildingedit.detailAddress.getCity(userLanguage)}&dealType=${deal_type}&assetClass=${asset_class}&language=${userLanguage}`
      const macroarea_url = `/searchresults?&macroAreaSelect=${macroAreaValue}&dealType=${deal_type}&assetClass=${asset_class}&language=${userLanguage}`

      setCityBreadCrumb(city_url)
      setBreadcrumbMacroArea(macroarea_url)
    }
    return

  }, [location, buildingedit, listmacroarea, userLanguage]);

  useEffect(() => {
    if (userLanguage && buildingedit.info) {
      const url = window.location.href;
      const originUrl = new URL(url).origin;
      const canonicalUrl = buildingedit.info.getCanonicalUrl(userLanguage);
      const head = document.head;
      //Set html lang attribute with the site language
      const html = document.documentElement;
      html.lang = isoLanguageMap[userLanguage];
      // Set canonical link
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        canonicalLink.href = originUrl + canonicalUrl;
      } else {
        const canonicalLink = document.createElement("link");
        canonicalLink.rel = "canonical";
        canonicalLink.href = originUrl + canonicalUrl;
        head.appendChild(canonicalLink);
      }
    }
  }, [userLanguage]);


  // useEffect(() => {
  //   console.log("adjacentListings debug: ", adjacentListings);
  // }, [adjacentListings]);


  return (
    <main className={globalClasses.maincontent}>
      <HeaderBuilding
        onChangeSolutions={handleClickSolutions}
        isBuildingPage={true}
        company={companyPage}
        Position="fixed"
        AppBarVisible={currentScrollY < 100 || companyPage}
        breadCrumpsBar={false}
        building={buildingedit}
        listunits={listunits}
        listcompany={listCompany}
        switchOnChange={SwitchOnChange}
        adjacentListings={adjacentListings}
        MobileScreen={MobileScreen}
        values={values}
        isFromSearch={isFromSearch}
        filteredUnits={filteredUnits}
        isToken={isToken}
      />
      {buildingedit.name !== "" && (
        <Fragment>
          <div className={classes.breadCrumbsSpace} />
          <Grid
            style={{
              padding: "10px 20px",
              fontSize: MobileScreen ? "14px" : "16px",
            }}
            container
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid md={6} xs={8} item>
              <a
                style={{ color: "#6a6a6a" }}
                href={`${cityBreadCrumb}`}
              >
                {buildingedit.detailAddress.getCity(userLanguage)}
              </a>{" "}
              {buildingedit.macroarea_list && (
                <>
                  {" "}
                  /{" "}
                  <a
                    style={{ color: "#6a6a6a" }}
                    href={`${breadcrumbMacroArea}`}
                  >
                    {buildingedit.macroarea_list !== null &&
                      buildingedit.macroarea_list !== "" && (
                        <>
                          {buildingedit.macroarea_list
                            .split(",")
                            .map(Number)
                            .map((item, id) => {
                              return (
                                <Fragment key={"macroarealist" + id}>
                                  {returnDescriptionById(
                                    item,
                                    listmacroarea,
                                    userLanguage
                                  )}{" "}
                                </Fragment>
                              );
                            })}
                        </>
                      )}
                  </a>{" "}
                </>
              )}
              {!MobileScreen && (
                <>
                  / {returnStringTranslation(buildingedit.name, userLanguage)}
                </>
              )}
            </Grid>
            <Grid
              md={6}
              xs={2}
              item
              container
              justifyContent="flex-end"
              wrap="nowrap"
              spacing={!MobileScreen && 2}
              alignItems="center"
            >
              <Grid item>
                {MobileScreen ? (
                  <div
                    onClick={() => {
                      setValue("map");
                      setOpenMediaModal(true);
                    }}
                  >
                    <img
                      style={{ marginRight: "10px" }}
                      src="/images/ico/lookOnTheMap.svg"
                    />
                  </div>
                ) : (
                  <Button
                    onClick={() => {
                      setValue("map");
                      setOpenMediaModal(true);
                    }}
                    style={{ fontSize: "16px", fontWeight: 600 }}
                    fullWidth={!MobileScreen && true}
                    variant={!MobileScreen && "outlined"}
                    className={!MobileScreen && classes.buttonMap}
                  >
                    <img
                      style={{ marginRight: "10px" }}
                      src="/images/ico/lookOnTheMap.svg"
                    />
                    {!MobileScreen && (
                      <div style={{ fontSize: "20px", fontWeight: 500 }}>
                        {dictionary.LookOnMap}
                      </div>
                    )}
                  </Button>
                )}
              </Grid>
              <Grid item>
                {MobileScreen ? (
                  <div
                    onClick={() => {
                      setValue(
                        images.length > 0
                          ? "gallery"
                          : buildingedit.virtual_tour !== null &&
                            buildingedit.virtual_tour !== "" &&
                            buildingedit.virtual_tour !== undefined
                          ? "virtual_view"
                          : buildingedit.video !== null &&
                            buildingedit.video !== "" &&
                            buildingedit.video !== undefined
                          ? "video"
                          : "map"
                      );
                      setOpenMediaModal(true);
                    }}
                  >
                    {" "}
                    <PlayCircleFilled
                      className={
                        !MobileScreen
                          ? classes.visualContentButton
                          : classes.visualContentButtonMobile
                      }
                      style={{ marginRight: "5px" }}
                    />
                  </div>
                ) : (
                  <Button
                    onClick={() => {
                      setValue(
                        images.length > 0
                          ? "gallery"
                          : buildingedit.virtual_tour !== null &&
                            buildingedit.virtual_tour !== "" &&
                            buildingedit.virtual_tour !== undefined
                          ? "virtual_view"
                          : buildingedit.video !== null &&
                            buildingedit.video !== "" &&
                            buildingedit.video !== undefined
                          ? "video"
                          : "map"
                      );
                      setOpenMediaModal(true);
                    }}
                    className={
                      !MobileScreen
                        ? classes.visualContentButton
                        : classes.visualContentButtonMobile
                    }
                    variant={!MobileScreen && "outlined"}
                  >
                    {" "}
                    <PlayCircleFilled style={{ marginRight: "5px" }} />
                    {!MobileScreen && "VISUAL CONTENTS"}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
          {/*This is the carousel element I need to resize*/}
          <div ref={elementRefCar}>
            <Carousel
              centerMode={true}
              centerSlidePercentage={MobileScreen ? 100 : 50}
              showIndicators={false}
              showThumbs={false}
              autoPlay={false}
              swipeable={false}
              dynamicHeight={false}
              infiniteLoop={true}
              showStatus={false}
              renderArrowPrev={(onClickHandler, hasPrev, label) =>
                hasPrev && (
                  <div
                    className={classes.ArrowsCarousel}
                    onClick={onClickHandler}
                    style={{ left: 15 }}
                  >
                    <LeftIcon
                      className={classes.IconArrow}
                      viewBox={"0 0 24 24"}
                      fill={"#ffffff"}
                      style={{ opacity: "0.8" }}
                    />
                    {/*   <img src="/images/ico/LeftArrowCarousel.svg" /> */}
                  </div>
                )
              }
              renderArrowNext={(onClickHandler, hasNext, label) =>
                hasNext && (
                  <div
                    className={classes.ArrowsCarousel}
                    onClick={onClickHandler}
                    style={{ right: 15 }}
                  >
                    <RightIcon
                      className={classes.IconArrow}
                      viewBox={"0 0 60 60"}
                      fill={"#ffffff"}
                      style={{ opacity: "0.8" }}
                    />
                    {/*  <img src="/images/ico/RightArrowCarousel.svg" /> */}
                  </div>
                )
              }
            >
              {images.map((item, index) => (
                <div className={classes.boxSlider}>
                  <img
                    key={"images" + index}
                    className={classes.imgSlider}
                    alt={returnStringTranslation(
                      item.description,
                      userLanguage
                    )}
                    src={item.image}
                  />
                </div>
              ))}
            </Carousel>
          </div>
          <Container className={classes.container}>
            <Grid container spacing={3}>
              <Grid item md={8} xs={12}>
                <div ref={elementRefBody}>
                  <Grid container spacing={3}>
                    <Grid
                      container
                      item
                      md={6}
                      xs={12}
                      style={{ textAlign: "end" }}
                    ></Grid>
                  </Grid>

                  <Grid container spacing={3}>
                    <Grid item md={12} xs={12}>
                      <Typography className={classes.SectionTitle} gutterBottom>
                        {dictionary.Highlights}
                      </Typography>
                      <Typography className={classes.SectionInfo} gutterBottom>
                        {parseHtml(
                          returnStringTranslation(
                            buildingedit.selling_points,
                            userLanguage
                          )
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  {isFromSearch ? (
                    <>
                      {filteredUnits.length !== listunits.length ? (
                        <Grid container spacing={2}>
                          <Grid
                            item
                            onClick={() => setSelectedSolution("matched")}
                          >
                            <div
                              style={{
                                borderBottom:
                                  selectedSolution === "matched"
                                    ? "2px solid #1c55e5"
                                    : "",
                              }}
                              className={classes.solutionsTab}
                            >
                              {MobileScreen ? (
                                <>{dictionary.matchedSolutionsShort}</>
                              ) : (
                                <>{dictionary.matchedSolutions}</>
                              )}{" "}
                              {`(${filteredUnits.length})`}
                            </div>
                          </Grid>
                          <Grid
                            onClick={() => setSelectedSolution("available")}
                            item
                          >
                            <div
                              style={{
                                borderBottom:
                                  selectedSolution === "available"
                                    ? "2px solid #1c55e5"
                                    : "",
                              }}
                              className={classes.solutionsTab}
                            >
                              {MobileScreen ? (
                                <>{dictionary.all}</>
                              ) : (
                                <>{dictionary.availableSolutions}</>
                              )}{" "}
                              {`(${listunits.length})`}
                            </div>
                          </Grid>
                        </Grid>
                      ) : (
                        <Grid container spacing={2}>
                          <Grid
                            item
                            onClick={() => setSelectedSolution("matched")}
                          >
                            <div
                              style={{
                                borderBottom:
                                  selectedSolution === "matched"
                                    ? "2px solid #1c55e5"
                                    : "",
                              }}
                              className={classes.solutionsTab}
                            >
                              {MobileScreen ? (
                                <>{dictionary.matchedSolutionsShort}</>
                              ) : (
                                <>{dictionary.matchedSolutions}</>
                              )}{" "}
                              {`(${filteredUnits.length})`}
                            </div>
                          </Grid>
                        </Grid>
                      )}
                    </>
                  ) : (
                    <Grid container spacing={2}>
                      <Grid item>
                        <div className={classes.solutionsTab}>
                          {MobileScreen ? (
                            <>{dictionary.all}</>
                          ) : (
                            <>{dictionary.availableSolutions}</>
                          )}{" "}
                          {`(${listunits.length})`}
                        </div>
                      </Grid>
                    </Grid>
                  )}

                  {listunits.length > 0 && (
                    <div ref={targetRef} style={{ scrollMarginTop: "180px" }}>
                      <Grid style={{ margin: "20px 0" }}>
                        {MobileScreen ? (
                          <UnitsTableMobile
                            listComm={listComm}
                            listTech={listTech}
                            units={
                              isFromSearch && selectedSolution === "matched"
                                ? filteredUnits
                                : listunits
                            }
                            dictionary={dictionary}
                            lang={userLanguage}
                            setFilteredUnits={setFilteredUnits}
                            setListUnits={setListUnits}
                            portfolio={isToken}
                            idPopperUnpayed={idPopperUnpayed}
                            handleMouseEnter={handleMouseEnter}
                            handleMouseLeave={handleMouseLeave}
                          />
                        ) : (
                          <UnitsTable
                            listComm={listComm}
                            listTech={listTech}
                            units={
                              isFromSearch && selectedSolution === "matched"
                                ? filteredUnits
                                : listunits
                            }
                            dictionary={dictionary}
                            lang={userLanguage}
                            setFilteredUnits={setFilteredUnits}
                            setListUnits={setListUnits}
                            portfolio={isToken}
                            idPopperUnpayed={idPopperUnpayed}
                            handleMouseEnter={handleMouseEnter}
                            handleMouseLeave={handleMouseLeave}
                          />
                        )}
                      </Grid>
                    </div>
                  )}

                  <Grid container direction="column">
                    <Grid item>
                      <Typography className={classes.SectionTitle} gutterBottom>
                        {dictionary.propertyOverview}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography className={classes.SectionInfo} gutterBottom>
                        {parseHtml(
                          returnStringTranslation(
                            buildingedit.description,
                            userLanguage
                          )
                        )}
                      </Typography>
                    </Grid>
                    <Grid
                      style={{ marginTop: "20px", marginBottom: "20px" }}
                      item
                      container
                      spacing={1}
                      direction={MobileScreen ? "column" : "row"}
                    >
                      {getFeaturesArray(buildingedit, dictionary).map(
                        (feature, id) => (
                          <Grid
                            item
                            xs={MobileScreen ? 12 : 6}
                            key={"features" + id}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "left",
                                alignItems: "center",
                              }}
                            >
                              <img
                                style={{
                                  width: "14px",
                                  height: "14px",
                                  marginRight: "10px",
                                }}
                                src="/images/ico/FeatureDot.svg"
                              />
                              <span>{feature}</span>
                            </div>
                          </Grid>
                        )
                      )}

                      {buildingedit.technical_features !== null &&
                        buildingedit.technical_features !== "" && (
                          <>
                            {buildingedit.technical_features
                              .split(",")
                              .map(Number)
                              .map((item, id) => {
                                if (
                                  returnDescriptionById(
                                    item,
                                    listTech,
                                    userLanguage
                                  ) !== ""
                                )
                                  return (
                                    <Grid
                                      item
                                      xs={MobileScreen ? 12 : 6}
                                      key={"tecnicalFeautures" + id}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "left",
                                          alignItems: "center",
                                        }}
                                      >
                                        <img
                                          style={{
                                            width: "14px",
                                            height: "14px",
                                            marginRight: "10px",
                                          }}
                                          src="/images/ico/FeatureDot.svg"
                                        />
                                        <span>
                                          {returnDescriptionById(
                                            item,
                                            listTech,
                                            userLanguage
                                          )}
                                        </span>
                                      </div>
                                    </Grid>
                                  );
                                else
                                  return (
                                    <Fragment
                                      key={"tecnicalFeautures" + id}
                                    ></Fragment>
                                  );
                              })}
                          </>
                        )}
                      {buildingedit.commercial_features !== null &&
                        buildingedit.commercial_features !== "" && (
                          <>
                            {buildingedit.commercial_features
                              .split(",")
                              .map(Number)
                              .map((item, id) => {
                                if (
                                  returnDescriptionById(
                                    item,
                                    listComm,
                                    userLanguage
                                  ) !== ""
                                )
                                  return (
                                    <Grid
                                      xs={MobileScreen ? 12 : 6}
                                      item
                                      key={"commercialFeautures" + id}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "left",
                                          alignItems: "center",
                                        }}
                                      >
                                        <img
                                          style={{
                                            width: "14px",
                                            height: "14px",
                                            marginRight: "10px",
                                          }}
                                          src="/images/ico/FeatureDot.svg"
                                        />
                                        <span>
                                          {returnDescriptionById(
                                            item,
                                            listComm,
                                            userLanguage
                                          )}
                                        </span>
                                      </div>
                                    </Grid>
                                  );
                                else return <></>;
                              })}
                          </>
                        )}
                    </Grid>
                  </Grid>

                  <Grid container direction="column">
                    <Grid item>
                      <Typography className={classes.SectionTitle} gutterBottom>
                        {dictionary.propertyDetails}
                      </Typography>
                    </Grid>
                    <Grid
                      container
                      item
                      spacing={1}
                      direction={MobileScreen ? "column" : "row"}
                    >
                      <Grid md={6} container item alignItems="center">
                        <Grid container spacing={4}>
                          <Grid xs={5} item>
                            {dictionary.BuildingType}
                          </Grid>
                          <Grid style={{ fontWeight: 500 }} item>
                            {getAssetClassesText(
                              buildingedit.asset_classes,
                              dictionary
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                      {buildingedit.garage > 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              Parking
                            </Grid>
                            <Grid
                              style={{
                                fontWeight: 500,
                              }}
                              item
                            >
                              <span style={{ marginRight: "5px" }}>
                                {buildingedit.garage}
                              </span>
                              <span>{dictionary.parkingSpaces}</span>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit.visitors_parking > 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.visitorParking}
                            </Grid>
                            <Grid
                              style={{
                                fontWeight: 500,
                              }}
                              item
                            >
                              <span style={{ marginRight: "5px" }}>
                                {buildingedit.visitors_parking}
                              </span>
                              <span>{dictionary.parkingSpaces}</span>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit.outdoor_car_parking > 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.outdoorParking}
                            </Grid>
                            <Grid
                              style={{
                                fontWeight: 500,
                              }}
                              item
                            >
                              <span style={{ marginRight: "5px" }}>
                                {buildingedit.outdoor_car_parking}
                              </span>
                              <span>{dictionary.parkingSpaces}</span>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit.size_archive > 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.SizeArchive}
                            </Grid>
                            <Grid
                              style={{
                                fontWeight: 500,
                              }}
                              item
                            >
                              <span style={{ marginRight: "5px" }}>
                                {buildingedit.size_archive}{" "}
                                {userLanguage === "gb" ? "mq" : "m²"}
                              </span>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit.size_terraces > 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.SizeTerraces}
                            </Grid>
                            <Grid
                              style={{
                                fontWeight: 500,
                              }}
                              item
                            >
                              <span style={{ marginRight: "5px" }}>
                                {buildingedit.size_terraces}{" "}
                                {userLanguage === "gb" ? "mq" : "m²"}
                              </span>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                      {buildingedit.floors > 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.numberOfFloors}
                            </Grid>
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.floors}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit.underground_floors > 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.number_of}{" "}
                              {dictionary.UndergroundFloors}
                            </Grid>
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.underground_floors}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                      {buildingedit.size && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.buildingSize}
                            </Grid>
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.size}{" "}
                              {userLanguage === "gb" ? "mq" : "m²"}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit.renovationgrade !== 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.Grade}
                            </Grid>
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.renovationgrade === 1 && "A"}
                              {buildingedit.renovationgrade === 2 && "B"}
                              {buildingedit.renovationgrade === 3 && "C"}
                              {buildingedit.renovationgrade === 4 && "A Green"}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit.charging_stations !== 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.chargingStations}
                            </Grid>
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.charging_stations}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                      {buildingedit.tenants_number > 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.number_of} {dictionary.tenants}
                            </Grid>
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.tenants_number}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                      {buildingedit.smart_building === 1 &&
                        buildingedit.smart_building_details && (
                          <Grid md={6} container item alignItems="center">
                            <Grid container spacing={4}>
                              <Grid xs={5} item>
                                Smart building
                              </Grid>
                              <Grid style={{ fontWeight: 500 }} item>
                                {buildingedit.smart_building_details}
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      {buildingedit.construction_status === 1 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.constructionYear}
                            </Grid>
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.construction_year}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit.construction_status === 2 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.refurbishmentYear}
                            </Grid>
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.refurbishment_year}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit.construction_status === 4 &&
                        buildingedit.delivery_date_refurbish && (
                          <Grid md={6} container item alignItems="center">
                            <Grid container spacing={4}>
                              <Grid xs={5} item>
                                {dictionary.deliveryDateRefurbish}
                              </Grid>
                              <Grid style={{ fontWeight: 500 }} item>
                                {buildingedit.delivery_date_refurbish}
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      {buildingedit.construction_status === 5 &&
                        buildingedit.delivery_date_construction && (
                          <Grid md={6} container item alignItems="center">
                            <Grid container spacing={4}>
                              <Grid xs={5} item>
                                {dictionary.deliveryDateConstruction}
                              </Grid>
                              <Grid style={{ fontWeight: 500 }} item>
                                {buildingedit.delivery_date_construction}
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      {buildingedit.construction_status === 0 &&
                        buildingedit.not_specified_open_field && (
                          <Grid md={6} container item alignItems="center">
                            <Grid container spacing={4}>
                              <Grid xs={5} item>
                                {dictionary.constructionStatus}
                              </Grid>
                              <Grid style={{ fontWeight: 500 }} item>
                                {buildingedit.not_specified_open_field}
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      {buildingedit.sustainability !== 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              LEED
                            </Grid>
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.sustainability === 1 && "Platinum"}
                              {buildingedit.sustainability === 2 && "Silver"}
                              {buildingedit.sustainability === 3 && "Gold"}
                              {buildingedit.sustainability === 4 &&
                                dictionary.leedOnGoing}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit.sustainability_breeam !== 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              BREEAM
                            </Grid>
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.sustainability_breeam === 1 &&
                                "Outstanding"}
                              {buildingedit.sustainability_breeam === 2 &&
                                "Excellent"}
                              {buildingedit.sustainability_breeam === 3 &&
                                "Very Good"}
                              {buildingedit.sustainability_breeam === 4 &&
                                "Good"}
                              {buildingedit.sustainability_breeam === 5 &&
                                "Pass"}
                              {buildingedit.sustainability_breeam === 6 &&
                                "Unclassified"}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit.workplace_wellness !== 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              WELL
                            </Grid>
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.workplace_wellness === 1 &&
                                "Platinum"}
                              {buildingedit.workplace_wellness === 2 && "Gold"}
                              {buildingedit.workplace_wellness === 3 &&
                                "Silver"}
                              {buildingedit.workplace_wellness === 4 &&
                                dictionary.wellOnGoing}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit.energy_performance_certificate !== 0 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.energyPerformanceCertificate}
                            </Grid>
                            <Grid xs={5} style={{ fontWeight: 500 }} item>
                              {buildingedit.energy_performance_certificate ===
                                1 && "A+"}
                              {buildingedit.energy_performance_certificate ===
                                2 && "A"}
                              {buildingedit.energy_performance_certificate ===
                                3 && "B"}
                              {buildingedit.energy_performance_certificate ===
                                4 && "C"}
                              {buildingedit.energy_performance_certificate ===
                                5 && "D"}
                              {buildingedit.energy_performance_certificate ===
                                6 && "E"}
                              {buildingedit.energy_performance_certificate ===
                                7 && "F"}
                              {buildingedit.energy_performance_certificate ===
                                8 && "G"}
                              {buildingedit.energy_performance_certificate ===
                                9 && dictionary.epcOnGoing}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                      {buildingedit.entrance_reception === 1 && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            <Grid xs={5} item>
                              {dictionary.entranceReception}
                            </Grid>
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.entrance_reception === 1 &&
                                "Reception"}
                              {buildingedit.entrance_reception === 2 &&
                                "24h Reception"}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit?.changing_rooms_lockers >= 0 && buildingedit?.changing_rooms_lockers != null && (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            {buildingedit?.changing_rooms_lockers === 0 ?
                                (<Grid xs={12} item>
                                  {dictionary.lockers}
                                </Grid>):
                              (<Grid xs={5} item>
                              {dictionary.lockers}
                            </Grid>)}
                            {buildingedit?.changing_rooms_lockers > 0  &&
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.changing_rooms_lockers}
                            </Grid>}
                          </Grid>
                        </Grid>
                      )}
                      {buildingedit?.archive_warehouse_area >= 0 && buildingedit?.archive_warehouse_area != null ?
                          (<Grid md={6} container item alignItems="center">
                            <Grid container spacing={4}>
                              {buildingedit?.archive_warehouse_area === 0  ? (
                                  <Grid xs={12} item>
                                    {dictionary.warehouseArea}
                                  </Grid>
                              ):(
                                  <Grid xs={5} item>
                                    {dictionary.warehouseArea}
                                  </Grid>)
                              }
                             {buildingedit.archive_warehouse_area > 0 &&
                                  <Grid style={{ fontWeight: 500 }} item>
                                    {buildingedit.archive_warehouse_area}{" "}
                                    {userLanguage === "gb" ? "mq" : "m²"}
                                  </Grid>}
                            </Grid>
                        </Grid>) : (<></>)
                      }
                      {buildingedit?.shared_rooftop_area >= 0 &&  buildingedit?.shared_rooftop_area != null ? (
                        <Grid md={6} container item alignItems="center">
                          <Grid container spacing={4}>
                            {buildingedit?.shared_rooftop_area === 0 ? (
                            <Grid xs={12} item>
                              {dictionary.sharedRooftopArea}
                            </Grid>):(
                            <Grid xs={5} item>
                              {dictionary.sharedRooftopArea}
                            </Grid>
                            )}
                            {buildingedit.shared_rooftop_area > 0 &&
                            <Grid style={{ fontWeight: 500 }} item>
                              {buildingedit.shared_rooftop_area}{" "}
                              {userLanguage === "gb" ? "mq" : "m²"}
                            </Grid>}
                          </Grid>
                        </Grid>
                      ) : (
                        <></>
                      )}
                    </Grid>
                  </Grid>
                  <Divider style={{ margin: "15px 0" }} />

                  {listdocs.length > 0 && (
                    <>
                      <Grid
                        style={{ marginTop: "10px", marginLeft: "0px" }}
                        container
                      >
                        {listdocs.map((doc) => (
                          <Grid
                            xs={6}
                            // style={{ margin: "0 2px" }}
                            item
                            container
                            alignItems="center"
                            spacing={1}
                            wrap="nowrap"
                          >
                            <Grid item>
                              <img src="/images/ico/UnitDownloadIcon.svg" />
                            </Grid>
                            <Grid item>
                              <a
                                target="_blank"
                                style={{ color: "#1c55e5" }}
                                href={doc.doc}
                              >
                                {doc.description ? (
                                  <>
                                    {returnStringTranslation(
                                      doc.description,
                                      userLanguage
                                    ) + ".pdf"}
                                  </>
                                ) : (
                                  <>{dictionary.documentUnit}</>
                                )}
                              </a>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                    </>
                  )}

                  <Grid
                    id="idmap"
                    style={{ marginTop: "10px" }}
                    container
                    spacing={3}
                  >
                    <Grid item md={12} xs={12}>
                      <Typography className={classes.SectionTitle} gutterBottom>
                        {dictionary.neighborhood}
                      </Typography>

                      <div className={classes.SectionInfo}>
                        <Typography
                          className={classes.AddressInfo}
                          gutterBottom
                        >
                          {buildingedit.info.getAddress(userLanguage)}
                        </Typography>

                        {buildingedit.macroarea_list !== null &&
                          buildingedit.macroarea_list !== "" && (
                            <Typography
                              className={classes.AddressInfo2}
                              gutterBottom
                            >
                              {buildingedit.macroarea_list
                                .split(",")
                                .map(Number)
                                .map((item) => {
                                  return (
                                    <Fragment>
                                      {returnDescriptionById(
                                        item,
                                        listmacroarea,
                                        userLanguage
                                      )}{" "}
                                    </Fragment>
                                  );
                                })}
                            </Typography>
                          )}

                        <GoogleMap
                          mapTypeId="roadmap"
                          onLoad={(map) => {
                            map.setZoom(15);
                            map.setCenter({
                              lat: buildingedit.lat,
                              lng: buildingedit.lng,
                            });
                            // map.setMapTypeId("SATELLITE");
                          }}
                          options={{
                            styles: [
                              {
                                featureType: "poi",
                                stylers: [{ visibility: "off" }],
                              },
                              {
                                featureType: "administrative",
                                stylers: [{ visibility: "off" }],
                              },
                            ],
                            // mapTypeId: "satellite",
                          }}
                          mapContainerStyle={containerStyle}
                        >
                          <Marker
                            position={{
                              lat: buildingedit.lat,
                              lng: buildingedit.lng,
                            }}
                            onClick={() => {
                              setSelectedCenter(buildingedit);
                            }}
                          ></Marker>
                        </GoogleMap>

                        {buildingedit.amenities !== null &&
                          buildingedit.amenities !== "" && (
                            <div style={{ paddingBottom: "15px" }}>
                              {JSON.parse(buildingedit.amenities).map(
                                (item, id) => {
                                  return (
                                    <BuildingAmenities
                                      item={item}
                                      id={id}
                                      amenitiesCount={
                                        buildingedit.amenities.length
                                      }
                                    />
                                  );
                                }
                              )}
                            </div>
                          )}
                      </div>
                    </Grid>
                  </Grid>

                  {listCompany.length > 0 && (
                    <Grid
                      container
                      style={{
                        border: "1px solid #d9d9d9",
                        marginTop: "20px",
                        padding: "20px",
                      }}
                    >
                      <Grid item md={12} xs={12}>
                        <Typography
                          className={classes.SectionTitle}
                          gutterBottom
                        >
                          {dictionary.Owner}
                        </Typography>

                        <div className={classes.SectionInfo}>
                          <Grid container direction="column" spacing={2}>
                            {listCompany.length > 0 &&
                              listCompany.map((company, index) => (
                                <Grid
                                  container
                                  item
                                  direction={
                                    MobileScreen ? "column-reverse" : "row"
                                  }
                                  spacing={!MobileScreen ? 3 : 1}
                                  alignItems={!MobileScreen && "center"}
                                >
                                  <Grid item md={9} xs={12}>
                                    <Typography
                                      className={classes.brokerName}
                                      color="textSecondary"
                                      gutterBottom
                                    >
                                      {company.companyname}
                                    </Typography>
                                  </Grid>
                                  <Grid item md={3} xs={12}>
                                    <img
                                      className={classes.brokerImage}
                                      // className={classes.ImageBroker}
                                      alt={`${company.companyname} Logo`}
                                      src={company.logo}
                                    />
                                  </Grid>
                                </Grid>
                              ))}
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>
                  )}
                </div>
              </Grid>

              <Grid item md={4} xs={12}>
                {!MobileScreen &&
                    <div style={{height: "100%", position:"relative"}}>
                      <BuildingFormCard
                          slug={slug}
                          listCompany={listCompany}
                          elementRefPaper={elementRefPaper}
                          LanguageContext={LanguageContext}
                          buildingedit={buildingedit}
                          listunits={listunits}
                          footerRef={footerRef}
                          elementRefCar={elementRefCar}
                      />
                    </div>
                    }
              </Grid>
            </Grid>
          </Container>{" "}
          {MobileScreen && (
            <Grid
              style={{
                position: "fixed",
                bottom: 0,
                backgroundColor: "white",
                boxShadow: "0px -2px 5px rgba(50, 50, 50, 0.2)",
              }}
              container
              justifyContent="center"
              alignItems="center"
            >
              <Grid item>
                <div
                  onClick={() => setOpenRequest(true)}
                  style={{
                    backgroundColor: "#1c55e5",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    fontSize: "18px",
                    fontFamily: 600,
                    margin: "20px",
                  }}
                >
                  {dictionary.regInfo}
                </div>
              </Grid>
            </Grid>
          )}
        </Fragment>
      )}
      <Popover
        id={idPopover}
        open={openPopover}
        anchorEl={anchorElPopover}
        onClose={() => setAnchorElPopover(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Grid
          style={{
            padding: "15px",
            overflow: "hidden",
            width: "500px",
            boxSizing: "border-box",
          }}
          container
          direction="column"
        >
          <Grid
            container
            justifyContent="space-between"
            style={{ fontSize: "20px", marginBottom: "15px" }}
            item
          >
            <Grid item>Share this listing with a link</Grid>
            <Grid item>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => setAnchorElPopover(null)}
              >
                <Close style={{ color: "#6a6a6a" }} />
              </div>
            </Grid>
          </Grid>
          <Grid style={{ marginBottom: "15px" }} item>
            <FormControl variant="outlined" fullWidth>
              <TextField
                disabled
                value={window.location.href}
                label="Link"
                variant="outlined"
              />
            </FormControl>
          </Grid>
          <Grid item container justifyContent="center">
            <button
              onClick={() => {
                if (!isCopied) {
                  setIsCopied(true);
                  navigator.clipboard.writeText(window.location.href);
                } else {
                  return;
                }
              }}
              style={{
                cursor: "pointer",
                border: "none",
                borderRadius: "5px",
                backgroundColor: "blue",
                color: "white",
                padding: "12px 40px",
              }}
            >
              {isCopied ? "Link copied" : "Copy link"}
            </button>
          </Grid>
        </Grid>
      </Popover>
      <Dialog
        fullScreen
        fullWidth
        classes={{ paper: classes.paper }}
        open={openRequest}
        onClose={handleCloseRequest}
        aria-labelledby="draggable-dialog-title"
      >
        <div style={{ padding: "10px 25px" }}>
          {" "}
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography
                className={classes.buildingName}
                color="textSecondary"
                gutterBottom
              >
                {dictionary.regInfo}
              </Typography>
            </Grid>
            <Grid item>
              <div onClick={handleCloseRequest}>
                <Close />
              </div>
            </Grid>
          </Grid>
          {listCompany.length > 0 && (
            <Grid container spacing={3}>
              {listCompany.map((company, index) => (
                <>
                  {index < 3 && (
                    <Grid xs={4} item>
                      <img
                        width="100%"
                        height="75px"
                        style={{ objectFit: "contain" }}
                        alt={`${company.companyname} Logo`}
                        src={company.logo}
                      />
                    </Grid>
                  )}
                </>
              ))}
            </Grid>
          )}
          <RequestInformationForm
            slug={slug}
            building={buildingedit}
            buildinglist={false}
            listunits={listunits}
          />
        </div>
      </Dialog>
      <BuildingMediaModal
        open={openMediaModal}
        setOpen={setOpenMediaModal}
        images={images}
        MobileScreen={MobileScreen}
        userLanguage={userLanguage}
        buildingedit={buildingedit}
        switchOnChange={SwitchOnChange}
        value={value}
        setValue={setValue}
      />
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.paper}>
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={() => setOpen(false)}
          >
            <Alert onClose={() => setOpen(false)} severity={alertseverity}>
              {alertmsg}
            </Alert>
          </Snackbar>
        </div>
      </Modal>
      <SendARequestDialog
        setOpenDialog={setRequestDialogOpen}
        openDialog={requestDialogOpen}
        handleClick={handleRequestDialogClick}
        setOpenHowItWorksDialog={setOpenHowItWorksDialog}
      />
      <SearchRequestsModal
        open={openSearchRequestsModal}
        closeDialog={handleCloseSearchRequestsModal}
        searchRequestData={searchRequestData}
        type="home_page"
      />
      <HowItWorksModal open={openHowItWorksDialog} closeDialog={()=>{setOpenHowItWorksDialog(false)}} setOpenSearchRequestsModal={setOpenSearchRequestsModal} />
      {buildingNotFound && (
        <Grid
          container
          style={{ height: "100%" }}
          justifyContent="center"
          alignItems="center"
        >
          <h1>404 Building Not Found</h1>
        </Grid>
      )}
      <div ref={footerRef}>
        <Footer company={companyPage} />
      </div>
      <Popper
          id={idPopperUnpayed}
          open={popperOpenUnpayed}
          anchorEl={anchorEl}
          placement="bottom-start"
          style={{zIndex: 2000}}
      >
        <div className={globalClasses.InfoPopper}>
          {dictionary.NeedToPay}{" "}
        </div>
      </Popper>

    </main>
  );
}
